<div class="moorl-support-link">
    <a
        :href="supportLink"
        rel="noopener"
        target="_blank"
    >
        {{ $tc(snippet) }}
    </a>
</div>